import { IPostsStoreState } from 'common/redux/posts/reducer';

import { IReduxState } from '../createStore';
import { IPostStoreState } from '../post/reducer';

export const getPosts = (state: IReduxState): IPostsStoreState => {
  return state.posts;
};

export const getAllPosts = (state: IReduxState): IPostStoreState[] => {
  const posts = getPosts(state).posts;
  if (Array.isArray(posts)) {
    return posts;
  }
  return [] as IPostStoreState[];
};

export const getTotalPosts = (state: IReduxState): number => {
  const { totalPosts } = getPosts(state);
  return totalPosts;
};

export const getTotalPages = (state: IReduxState): number => {
  const { totalPages } = getPosts(state);
  return totalPages;
};
